import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';

export type RbdmCmdiUserCountResponse =
	| number
	| {
			cmdi_code?: string;
			user_count?: number;
			ob_user_count?: number;
			data?: number | { cmdi_code?: number; user_count?: number; ob_user_count?: number };
	  };

export const useRbdmCmdiUserCountQuery = (cmdiCode: string = ''): IQueryResponse<RbdmCmdiUserCountResponse> => {
	const fetchCmdiUserCount = async (): Promise<RbdmCmdiUserCountResponse> => {
		return APIService.getData<RbdmCmdiUserCountResponse>(APICONFIG.RBDM_CMDI_USER_COUNT, {
			cmdi_code: cmdiCode,
			limit: '0',
		});
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['rbdm-cmdi-user-count', cmdiCode],
		queryFn: fetchCmdiUserCount,
		enabled: !!cmdiCode,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
